// Carries the landing page's trial box into the signup wizard across a
// module boundary (docs/frontend-modules-plan.md §7, mechanism 1).
//
// This used to be React Router state, which works only for a client-side
// navigation within one router. The landing page is now its own module, so
// reaching /sign-up is a document load and that state is gone.
//
// sessionStorage rather than a query parameter, for the reason
// analytics/urls.js exists: `?user_hint=<email>` would put an address into
// the URL bar, into the analytics pipeline (which then has to strip it back
// out), into the browser's history, and into any Referer this page emits.
// The tab-scoped store carries the same value and none of that. It is also
// the same window analytics/events.js already chose for the signup-source
// handoff, for the same reason - a module variable does not survive a
// document swap, and localStorage would resurrect a week-old value.
//
// Phase 3 replaces this with a server-templated shell (§7a): the landing box
// creates the account itself, and the auth module's shell reads the
// resulting session server-side, so nothing has to be handed over at all.
// This is the interim, and it is strictly better than the query parameter it
// avoids.
//
// PREFILL IS NOT AUTHORITATIVE. It fills two form fields the visitor is
// about to see and can edit. Nothing downstream may trust it.
const KEY = 'writeup:signup-prefill';

export function stashSignupPrefill({ name, email }) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ name: name || '', email: email || '' }));
  } catch {
    // Private-mode/quota. The wizard simply opens on step 1 with empty
    // fields, which is the same thing a direct visit to /sign-up gets.
  }
}

// Read-and-clear: a prefill is consumed by the screen it was handed to, so
// a later visit to /sign-up in the same tab starts clean rather than
// re-opening someone else's half-typed details.
export function takeSignupPrefill() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    return parsed?.email ? parsed : null;
  } catch {
    return null;
  }
}
